// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 825 ? "npm.xlsx" : chunkId) + "." + {"490":"147957d3","712":"fcd9c92b","825":"33e55a59","3076":"09fe8bc7","3576":"95e8d521","4931":"90fe70df","6927":"81fcd71c","7252":"6e2bba0a","7279":"7a507527","7953":"c4c6c6e3","8943":"f545b984","9720":"b5269a75","9888":"aa0ff30b"}[chunkId] + ".js";
};